<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Customer Grower Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Edit Customer Grower" class="mb-3" />

    <permission-alert-gate :permissions="['edit customer grower']">
      <template #gated-content>
        <CustomerGrowerForm
          :customer_grower="customer_grower"
          @submit="submit"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import BasicHeading from '@/components/shared/BasicHeading'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import CustomerGrowerForm from '@/components/crm/customergrower/form/CustomerGrowerForm'
import { getModel } from '@/shared/fetch-utils'
import { notificationOptions } from '@/shared/toast-notification-options'
import { customerGrowerNotifications } from '@/shared/notifications'
import { CrmRepositoryFactory } from '@/repositories/crm/CrmRepositoryFactory'

const CustomerGrowersRepository = CrmRepositoryFactory.get('customerGrowers')

Vue.use(VueNotifications, notificationOptions)

export default {
  name: 'CustomerGrowerEdit',
  components: {
    BasicHeading,
    PermissionAlertGate,
    CustomerGrowerForm
  },
  data () {
    return {
      loading: true,
      customer_id: this.$route.params.customer_id,
      customer_grower_id: this.$route.params.customer_grower_id || null,
      customer_grower: null
    }
  },
  async created () {
    this.loading = true

    this.customer_grower = await getModel({
      model_type: 'customer_grower',
      id: this.customer_grower_id,
      message: this.$bvToast
    })

    this.customer_grower ? (this.loading = false) : this.$router.back()
  },
  methods: {
    async submit (form_data) {
      try {
        const { data } = await CustomerGrowersRepository.update(this.customer_grower_id, {
          customer_id: this.customer_id,
          ...form_data
        })

        this.addSuccess()
        this.$router.push(`/customer/${data.customer_id}`)
      } catch ({ response }) {
        const { status, data } = response

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: 'Server Error.',
          variant: 'danger',
        })
      }
    }
  },
  notifications: customerGrowerNotifications
}
</script>
